/*
 * Выводит список с типом поддерживаемых банковских карт.
 */

import * as config from 'config';
import * as templates from 'modules/templates';

export function create(container, template) {
    var cardTypes = config.purchase['card-types'];

    if (!cardTypes) {
        return;
    }

    templates.get(template, function (err, tpl) {
        var data;

        if (err) {
            return;
        }

        data = Object
                .keys(cardTypes)
                .filter(cardName => cardTypes[cardName].enabled)
        .map(cardName => ({name: cardTypes[cardName].name, type: cardName}));

        container.append(tpl.render({cardTypes: data}));
    });
}

